// JsFromRoutes CacheKey f936fefc62d94b2d324368feffe19fc3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/add-back/prompts/send_test_email'),
}
